import { render, staticRenderFns } from "./RealValuePue.vue?vue&type=template&id=581fc850&scoped=true&"
import script from "./RealValuePue.vue?vue&type=script&lang=js&"
export * from "./RealValuePue.vue?vue&type=script&lang=js&"
import style0 from "./RealValuePue.vue?vue&type=style&index=0&id=581fc850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581fc850",
  null
  
)

export default component.exports